import { PageSection } from 'types/Sections';

export const getEnableSections = (sections: PageSection[]) => {
  return sections.filter(section => section.enable);
};
